module.exports = __webpack_public_path__ + "static/egg-rttd-menu-screen-0874ab701f4344c46742c4620147fa91.png";